<template>
  <div>
    <h2>Benutzer</h2><br>
    <table v-once v-bind:id=tableId class="dataTable table table-striped table-bordered" width="100%" cellspacing="0">
      <thead>
      <tr>
        <th>Optionen</th>
        <th>Nachname</th>
        <th>Vorname</th>
        <th>Fahrerlaubnisklassen</th>
        <th>Führerschein Nr.</th>
        <th>RFID Nr.</th>
        <th>E-Mail</th>
        <th>E-Mail dienstlich</th>
        <!--<th>Mobil</th>
        <th>SMS Versand</th>-->
        <th>E-Mail Versand</th>
        <th>Rechte</th>
      </tr>
      </thead>
    </table>
    <div>
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
/* global $ */

export default {
  name: 'User',
  props: ['id'],
  data () {
    return {
      rfidCodes: [],
      // eslint-disable-next-line no-undef
      tableId: (this.$props.id !== undefined) ? 'dTable_' + this.$func.uuid() + '_' + this.$props.id : 'dTable_' + this.$func.uuid()
    }
  },
  computed: {},
  async mounted () {
    await this.$store.dispatch('selectize/fetchSkills')
    var store = (this.$store)
    var router = this.$router
    var tableId = this.tableId
    var self = this

    this.$func.loadDatatable(
      () => $(document).ready(function () {
        const ouOpts = {
          plugins: ['remove_button'],
          maxItems: null,
          valueField: 'id',
          searchField: ['sName'],
          placeholder: 'Standort auswählen ...',
          preload: true,
          options: [],
          sortField: [{
            field: 'sName',
            direction: 'asc'
          }, {
            field: '$score'
          }],
          create: false,
          render: {
            option: function (data, escape) {
              return '<div>' + escape(data.sName) + '</div>'
            },
            item: function (item, escape) {
              return '<div>' + escape(item.sName) + '</div>'
            }
          },
          load: function (query, callback) {
            callback(store.getters.getLocations)
          }
        }

        const ouOptSingle = {
          plugins: [],
          maxItems: 1,
          valueField: 'id',
          searchField: ['sName'],
          placeholder: 'Standort auswählen ...',
          preload: true,
          options: [],
          sortField: [{
            field: 'sName',
            direction: 'asc'
          }, {
            field: '$score'
          }],
          create: false,
          render: {
            option: function (data, escape) {
              return '<div>' + escape(data.sName) + '</div>'
            },
            item: function (item, escape) {
              return '<div>' + escape(item.sName) + '</div>'
            }
          },
          load: function (query, callback) {
            callback(store.getters.getLocations)
          }
        }

        const skills = {
          plugins: ['remove_button'],
          maxItems: null,
          valueField: 'id',
          searchField: ['sBezeichnung'],
          placeholder: 'Fahrerlaubnisklasse auswählen ...',
          preload: true,
          options: [],
          sortField: [{
            field: 'sBezeichnung',
            direction: 'asc'
          }, {
            field: '$score'
          }],
          create: false,
          render: {
            option: function (data, escape) {
              return '<div>' + escape(data.sBezeichnung) + '</div>'
            },
            item: function (item, escape) {
              return '<div>' + escape(item.sBezeichnung) + '</div>'
            }
          },
          load: function (query, callback) {
            callback(store.getters['selectize/getSkills'])
          }
        }

        // eslint-disable-next-line no-undef
        var editor = new $.fn.dataTable.Editor({
          ajax: {
            create: self.$func.addAuth({
              type: 'POST',
              url: '/user/'
            }),
            edit: self.$func.addAuth({
              type: 'PUT',
              url: '/user/_id_/'
            }),
            remove: self.$func.addAuth({
              type: 'DELETE',
              url: '/user/_id_/',
              deleteBody: false
            })
          },
          idSrc: 'id',
          table: '#' + tableId,
          fields: [{
            label: 'Nachname:',
            name: 'sLastname'
          }, {
            label: 'Vorname:',
            name: 'sFirstname'
          }, {
            label: 'Fahrerlaubnisklassen:',
            name: 'oSkill_arr',
            type: 'selectize',
            closeAfterSelect: true,
            opts: skills
          }, {
            label: 'Führerschein Nr.:',
            name: 'sFsNr'
          }, {
            label: 'RFID Nr.:',
            name: 'sRfidcode',
            type: 'text'
          }, {
            label: 'E-Mail-Adresse:',
            name: 'sEmail'
          }, {
            label: 'E-Mail-Adresse dienstlich:',
            name: 'sEmailDienstlich'
          }, /* {
            label: 'Mobil:',
            name: 'sMobile'
          }, {
            label: 'Benachrichtigung SMS:',
            name: 'bAlertSms',
            type: 'checkbox',
            options: {
              '': '1'
            },
            separator: ','
          }, */ {
            label: 'Benachrichtigung E-Mail:',
            name: 'bAlertEmail',
            type: 'checkbox',
            options: {
              '': '1'
            },
            separator: ','
          }, {
            label: 'Standorte:',
            name: 'oOu_arr',
            type: 'selectize',
            closeAfterSelect: true,
            opts: ouOpts
          }, {
            label: 'Abrechnungsstandort:',
            name: 'oInvoiceOu',
            type: 'selectize',
            closeAfterSelect: true,
            opts: ouOptSingle
          }
          ]
        })

        $('#' + tableId).DataTable({
          dom: 'BfQrtip', // BUTTON/FIND/PROCESSING/TABLE/INFO/PAGING
          ajax: self.$func.addAuth({
            url: '/user/',
            type: 'GET'
          }),
          order: [[1, 'asc']],
          scrollX: true,
          scrollCollapse: true,
          columns: [
            {
              class: 'center not-export-col',
              data: null,
              render: function (data, type, row) {
                // eslint-disable-next-line no-unused-vars
                var edit = '<i title="Bearbeiten" class="dt-edit fas fa-pen fa-lg pointer text-secondary"></i>'
                var files = '<i title="Dateien" class="dt-files fas fa-paperclip fa-lg pointer text-secondary"></i>'
                var key = '<i title="Rechte" class="dt-rechte fas fa-key fa-lg pointer text-secondary"></i>'
                return edit + key + files
              }
            },
            {
              class: 'center',
              data: 'sLastname'
            },
            {
              class: 'center',
              data: 'sFirstname'
            },
            {
              class: 'center',
              data: null,
              render: function (data, type, row) {
                return data.oSkill_arr.map(x => {
                  return x.sBezeichnung
                }).join(',<br>')
              }
            },
            {
              class: 'center',
              data: 'sFsNr'
            }, {
              class: 'center',
              data: 'oRfidcode.sPublicId'
            },
            {
              class: 'center',
              data: 'sEmail'
            },
            {
              class: 'center',
              data: 'sEmailDienstlich'
            },
            /* {
              class: 'center',
              data: 'sMobile'
            }, {
              class: 'center',
              data: null,
              render: function (data, type, row) {
                return (data.bAlertSms == '1') ? 'X' : ''
              }
            }, */{
              class: 'center',
              data: null,
              render: function (data, type, row) {
                return (data.bAlertEmail == '1') ? 'X' : ''
              }
            },
            {
              class: 'center',
              data: null,
              render: function (data, type, row) {
                return data.oPermission_arr.map(x => {
                  return x.oPermissionGroupe.sBezeichnung
                }).join(',<br>')
              }
            }
          ],
          initComplete: function (settings, json) {
            // $('#' + tableId).DataTable().searchPanes.rebuildPane()
          },
          buttons: self.$func.addDefaultButtons([
            {
              extend: 'create',
              editor: editor
            },
            {
              extend: 'edit',
              editor: editor
            },
            {
              extend: 'remove',
              editor: editor
            }
          ])
        })

        $('#' + tableId).on('click', '.dt-files', function (e) {
          e.preventDefault()
          var tr = $(this).closest('tr')
          var row = $('#' + tableId).DataTable().row(tr)
          var id = row.data().id

          router.push({
            name: 'userfiles',
            params: {
              id: id,
              context: 'user',
              payload: row.data()
            }
          })
        })

        $('#' + tableId).on('click', '.dt-rechte', function (e) {
          e.preventDefault()
          var tr = $(this).closest('tr')
          var row = $('#' + tableId).DataTable().row(tr)
          var id = row.data().id

          router.push({
            name: 'userpermissions',
            params: {
              id: id,
              context: 'user',
              payload: row.data()
            }
          })
        })

        $('#' + tableId).on('click', '.dt-edit', function (e) {
          editor
            .edit($(this).closest('tr'))
            .title($.fn.dataTable.Editor.defaults.i18n.edit.title)
            .buttons({
              label: $.fn.dataTable.Editor.defaults.i18n.edit.submit,
              className: 'btn btn-primary',
              fn: function () {
                editor.submit()
              }
            })
        })

        $('#' + tableId + ' tbody').on('dblclick', 'tr', function () {
          editor
            .edit(this)
            .title($.fn.dataTable.Editor.defaults.i18n.edit.title)
            .buttons({
              label: $.fn.dataTable.Editor.defaults.i18n.edit.submit,
              className: 'btn btn-primary',
              fn: function () {
                editor.submit()
              }
            })
        })

        editor.on('preOpen', function (e, mode, action) {
          if (action === 'create') {
            editor.field('oOu_arr').set(store.getters.getLocation.id)
            editor.field('oInvoiceOu').set(store.getters.getLocation.id)
          }
          if (store.getters.getLocations.length === 1) {
            editor.field('oOu_arr').hide()
            editor.field('oInvoiceOu').hide()
          } else {
            editor.field('oOu_arr').show()
            editor.field('oInvoiceOu').show()
          }
        })
      }))
  }
}
</script>
<style>

</style>
